var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38307",
    "data-name": "Group 38307",
    transform: "translate(-311 -385.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7674",
    "data-name": "Rectangle 7674",
    width: 31,
    height: 31,
    rx: 5,
    transform: "translate(311 385.182)",
    fill: "#c7b9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_exam_3054500",
    transform: "translate(319.925 391.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38306",
    "data-name": "Group 38306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65504",
    "data-name": "Path 65504",
    d: "M139.727,23.226h.542v1.392a1.825,1.825,0,0,0,1.819,1.819h4.96a1.825,1.825,0,0,0,1.819-1.819V23.226h.542a1.552,1.552,0,0,1,1.547,1.547V38.255A1.552,1.552,0,0,1,149.41,39.8h-9.683a1.552,1.552,0,0,1-1.547-1.547V24.773A1.552,1.552,0,0,1,139.727,23.226Zm2.361-1.416h4.96a.993.993,0,0,1,.991.99v1.818a.993.993,0,0,1-.991.991h-4.96a.993.993,0,0,1-.991-.991V22.8A.993.993,0,0,1,142.089,21.81Zm-1.813,6.539.675.663,1.487-1.63.653.594-2.1,2.307-1.328-1.305Zm3.127.668h6.078v.863H143.4Zm-3.127,3.389.675.663,1.487-1.63.653.594-2.1,2.307-1.328-1.305Zm3.127.668h6.078v.863H143.4Zm-3.127,3.389.675.663,1.487-1.63.653.594-2.1,2.307-1.328-1.305Zm3.127.668h6.078V38H143.4Z",
    transform: "translate(-138.18 -21.81)",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/Assessment.397e987878644830ea17309f76672445.svg";
export { ForwardRef as ReactComponent };